<template>
  <div class="mb-3" v-if="response && response.numFound">
    <b-button-toolbar>
<!--      <b-button-group size="sm">  -->
        <b-button v-if="!disableResetFilters && base_urls" v-bind:data-actionurl="this.base_urls.remove_all_filters.sem_url_action" v-on:click.prevent="callAction" :disabled="disableResetFilters"  variant="primary" size="sm" class="mr-1">
          {{$t('filters.reset_filters')}}
        </b-button>

        <!--
        <b-button v-if="autofilterMatches && base_urls && base_urls.enable_autofilter" v-bind:data-actionurl="this.base_urls.enable_autofilter.sem_url_action" v-on:click.prevent="callAction" variant="primary" size="sm" class="mr-1">
          {{$t('filters.enable_autofilter')}}
        </b-button>
        <b-button v-if="autofilterMatches && base_urls && base_urls.disable_autofilter" v-bind:data-actionurl="this.base_urls.disable_autofilter.sem_url_action" v-on:click.prevent="callAction" variant="primary" size="sm" class="mr-1">
          {{$t('filters.disable_autofilter')}}
        </b-button>

        -->

        <b-button v-if="suggestedfilters && base_urls && base_urls.reset_autofilter" v-bind:data-actionurl="this.base_urls.reset_autofilter.sem_url_action" v-on:click.prevent="callAction" variant="primary" size="sm" class="mr-1">
          {{$t('filters.reset_autofilter')}}
        </b-button>
        <b-button v-if="hasActiveAutofilter && base_urls && base_urls.dont_apply_autofilter" v-bind:data-actionurl="this.base_urls.dont_apply_autofilter.sem_url_action" v-on:click.prevent="callAction" variant="primary" size="sm" class="mr-1">
          {{$t('filters.dont_apply_autofilter')}}
        </b-button>

        <b-button v-if="semanticGraph && showSemanticGraph" v-on:click.prevent="toggleSemanticGraph" variant="primary" size="sm" class="mr-1">
          Hide semantics
        </b-button>
        <b-button v-if="semanticGraph && !showSemanticGraph" v-on:click.prevent="toggleSemanticGraph" variant="primary" size="sm" class="mr-1">
          Show semantics
        </b-button>

      <!--</b-button-group>-->
    </b-button-toolbar>
  </div>
</template>

<script>
export default {
  name: 'toolbar',
  data () {
    return {
      selected: null
    }
  },
  methods: {
    callAction: function (e) {
      this.$router.push(e.srcElement.getAttribute('data-actionurl'));
    },
    toggleSemanticGraph: function (e) {
      this.$store.commit('toggleSemanticGraph')
    }
  },
  components: {
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    disableResetFilters () {
      var foundUserFilter = false;
      if (this.$store.state.response &&
          this.$store.state.response.active_filters &&
          this.$store.state.response.active_filters.filters) {
        this.$store.state.response.active_filters.filters.forEach(function (f) {
          if (f.source === 'USER') {
            foundUserFilter = true;
          }
        });
      }
      return !foundUserFilter;
    },
    base_urls () {
      if (this.$store.state.response && this.$store.state.response.base_urls && this.$store.state.response.base_urls) {
        return this.$store.state.response.base_urls;
      }
      return null;
    },
    semanticGraph () {
      if (this.$store.state.response &&
          this.$store.state.response.semanticgraph &&
          this.$store.state.response.semanticgraph.matches && this.$store.state.response.semanticgraph.matches.length >0) {
        return this.$store.state.response.semanticgraph.matches
      }
      return null;
    },
    showSemanticGraph () {
      return this.$store.state.showSemanticGraph;
    },
    autofilterMatches () {
      if (this.$store.state.response &&
          this.$store.state.response.autofilter &&
          this.$store.state.response.autofilter.matches &&
          this.$store.state.response.autofilter.matches.length >0) {
        return this.$store.state.response.autofilter.matches
      }
      return null;
    },
    suggestedfilters () {
      if (this.$store.state.response &&
          this.$store.state.response.suggested_filters &&
          Object.keys(this.$store.state.response.suggested_filters).length > 0) {
        return this.$store.state.response.suggested_filters
      }
      return null;
    },
    hasActiveAutofilter () {
      var foundSystemFilter = false;
      if (this.$store.state.response &&
          this.$store.state.response.active_filters &&
          this.$store.state.response.active_filters.filters) {
        this.$store.state.response.active_filters.filters.forEach(function (f) {
          if (f.source === 'SYSTEM') {
            foundSystemFilter = true;
          }
        });
      }
      return foundSystemFilter;
    },
  }
}
</script>

<style scoped>
</style>
